import * as React from 'react';

export default function PageOutro({ content, instant, extraClassNames }) {
  return (
    <div className={`page-outro ${instant ? 'instant' : ''} ${extraClassNames}`}>
      <div className="inner">{content}</div>
    </div>
  );
}
